// extracted by mini-css-extract-plugin
export default {"child":"Oyv3wo","fitCover":"fsUnQa","fitContain":"HQDFTQ"};